import changeActiveSurfaceAndPersist from '../actions/changeActiveSurfaceAndPersist';
import changeActiveSurface from '../actions/changeActiveSurface';
import { ACTIVE_CALENDAR_SURFACE_VIEW } from '../utils/constants';
import { setItem } from 'mini-localstorage';
import { orchestrator } from 'satcheljs';

/**
 * Orchestrates changing active surface and persist.
 */
export default orchestrator(changeActiveSurfaceAndPersist, async ({ newSurface }) => {
    // persist in session store.
    setItem(ACTIVE_CALENDAR_SURFACE_VIEW, newSurface.toString());
    // change the active surface value in store.
    changeActiveSurface(newSurface);
});
